import { createAction } from 'redux-actions'

export const clearMembershipCardOrderStatus = createAction(
  'CLEAR_MEMBERSHIP_CARD_ORDER_STATUS'
)
